import React, { Component } from 'react';

class IconCategoryIssueInfo extends Component {
    render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" viewBox="0 0 38 38">
                <path
                    fill="#424242"
                    d="M20.302 23.688c-.126 0-.236-.032-.278-.085-.034-.042-.05-.117-.05-.223 0-.17.008-.426.058-.649.203-.957.414-1.904.625-2.85.168-.734.202-1.33.135-1.904-.119-.872-.827-1.574-1.654-1.638-.743-.053-1.393.245-2.026.532l-.227.106a.558.558 0 00-.296.373c-.042.17-.076.34-.101.51l-.152.766.49-.128c.092-.021.177-.053.261-.074.16-.053.32-.096.49-.107.177-.01.312.011.37.085.06.075.051.245.043.33a12.32 12.32 0 01-.211 1.319c-.067.35-.152.702-.236 1.042-.177.723-.363 1.479-.405 2.276-.034.766.194 1.372.675 1.808.371.33.785.49 1.266.49a2.7 2.7 0 00.633-.086c.362-.085.7-.244 1.037-.393.127-.053.254-.117.38-.17a.599.599 0 00.304-.383c.034-.15.067-.298.093-.447l.143-.712-.768.117a1.959 1.959 0 01-.599.095zM19.668 15a2 2 0 100-4 2 2 0 000 4z"
                ></path>
                <path
                    fill="#424242"
                    fillRule="evenodd"
                    d="M18.987 3C27.832 2.987 35.013 10.158 35 19.006 34.987 27.854 27.857 34.987 19.013 35 10.18 35.026 2.987 27.84 3 18.994 3.013 10.158 10.143 3.013 18.987 3zm.026 3.186C11.986 6.173 6.21 11.926 6.185 18.98c-.026 7.029 5.711 12.794 12.79 12.846 7.013.052 12.84-5.765 12.84-12.82 0-7.043-5.75-12.808-12.802-12.821z"
                    clipRule="evenodd"
                ></path>
            </svg>
        );
    }
}

export default IconCategoryIssueInfo;